export default "__VITE_ASSET__CKEu2UNi__"